import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[pmUiBlurOnEnter]'
})
export class BlurOnEnterDirective {
    @HostListener('keydown', ['$event']) onEvent(evt: KeyboardEvent): void {
        window.setTimeout(() => {
            const code = evt.keyCode || evt.charCode || evt.which;
            const key = evt.key;

            if (code === 13 || key === 'Enter') {
                evt.preventDefault();
                evt.stopPropagation();
                this.setNextFucus(evt.target as HTMLElement);
            }
        });
    }

    private setNextFucus = (element: HTMLElement): void => {
        if (!element)
            return;

        const elements = document.querySelectorAll('*');

        let idx = -1;
        for (let x = 0; x < elements.length; x++) {
            if (elements[x] === element) {
                idx = x;
                break;
            }
        }

        if (idx !== -1) {
            for (let x = idx + 1; x < elements.length; x++) {
                const nextElement = elements[x] as HTMLElement;

                if (nextElement && (
                    (nextElement.tagName === 'SELECT' && (nextElement as HTMLSelectElement).disabled === false)
                    || (nextElement.tagName === 'INPUT' && (nextElement as HTMLInputElement).disabled === false)
                    || (nextElement.tagName === 'BUTTON' && (nextElement as HTMLButtonElement).disabled === false)
                    || (nextElement.tagName === 'TEXTAREA' && (nextElement as HTMLTextAreaElement).disabled === false))) {
                    element.blur();
                    nextElement.focus();
                    break;
                }
            }
        }
    }
}

